module.exports = __webpack_public_path__ + "img/austria.dd9515ba.svg";